import AddUserManagementFormContainer from "./AddUserManagementFormContainer";

export default AddUserManagementFormContainer;
